/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * DailyInspirationAcfBase
 * auto generated base class for the model DailyInspirationAcfModel.
 */
export const DailyInspirationAcfModelBase = ModelBase.named('DailyInspirationAcf')
  .props({
    __typename: types.optional(types.literal('DailyInspirationACF'), 'DailyInspirationACF'),
    day: types.union(types.undefined, types.string),
    external_or_discussion_link: types.union(types.undefined, types.string),
    motivational_message: types.union(types.undefined, types.string),
    week: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DailyInspirationAcfModelSelector extends QueryBuilder {
  get day() {
    return this.__attr('day')
  }
  get external_or_discussion_link() {
    return this.__attr('external_or_discussion_link')
  }
  get motivational_message() {
    return this.__attr('motivational_message')
  }
  get week() {
    return this.__attr('week')
  }
}
export function selectFromDailyInspirationAcf() {
  return new DailyInspirationAcfModelSelector()
}

export const dailyInspirationAcfModelPrimitives =
  selectFromDailyInspirationAcf().day.external_or_discussion_link.motivational_message.week
